import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';

import { requestToggleFavorite as requestToggleFavoriteAction } from 'services/actions/productsActions';
import withSelectedCategoryId from 'HOC/withSelectedCategoryId/withSelectedCategoryId';
import styles from './FavButton.module.css';

const FavButton = ({
  requestToggleFavorite,
  productId,
  variantId,
  isFavorite,
  buttonLocation,
  selectedCategoryId,
  positionLocation,
  referrerProductId,
  positionOrder,
  favBtnStyles,
}) => {
  const [isSetting, setIsSetting] = useState(false);
  const animationType = isFavorite ? 'enlarge' : 'shrink';
  const icon = isFavorite ? 'fas fa-heart' : 'far fa-heart';

  const setAsFavorite = (e) => {
    e.preventDefault();
    setIsSetting(true);
    requestToggleFavorite(
      productId,
      variantId,
      buttonLocation,
      !isFavorite,
      selectedCategoryId,
      positionLocation,
      referrerProductId,
      positionOrder
    );
    setTimeout(() => {
      setIsSetting(false);
    }, 150);
  };

  return (
    <button
      style={favBtnStyles}
      className={classNames(styles.favButton, {
        [styles[animationType]]: isSetting,
        [styles.favorite]: isFavorite,
      })}
      onClick={setAsFavorite}
      data-dd-action-name="Favorite button"
      type="button"
      data-testid="fav-btn"
    >
      <i className={icon} />
    </button>
  );
};

FavButton.propTypes = {
  requestToggleFavorite: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  variantId: PropTypes.string.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  buttonLocation: PropTypes.string.isRequired,
  selectedCategoryId: PropTypes.string,
  positionLocation: PropTypes.string.isRequired,
  referrerProductId: PropTypes.string,
  positionOrder: PropTypes.string,
  favBtnStyles: PropTypes.shape({}),
};

FavButton.defaultProps = {
  selectedCategoryId: null,
  referrerProductId: null,
  positionOrder: null,
  favBtnStyles: {},
};

export default compose(
  withSelectedCategoryId,
  connect(null, {
    requestToggleFavorite: requestToggleFavoriteAction,
  })
)(FavButton);
